import { useContext } from 'react';

// @ts-ignore - no types for ar-feature-gating
import { splitClient } from '@nextroll/ar-feature-gating';
import i18n from '@nextroll/ar-i18n';
// @ts-ignore - no types for ar-style-base
import { Logo } from '@nextroll/ar-style-base';

import { MARKETING_WEBSITE_URLS } from '../constants';
import ThemeWrapperContext from '../contexts/ThemeWrapperContext';

const Header = ({ className }: { className?: string }) => {
    const { businessUnit } = useContext(ThemeWrapperContext);

    return (
        <div id='business-logo' className={`eh-header ${className}`.trim()}>
            <a
                href={MARKETING_WEBSITE_URLS[businessUnit]}
                aria-label='go to marketing site'
            >
                <Logo i18n={i18n} businessUnit={businessUnit} />
            </a>
        </div>
    );
};

export default Header;
